//Home Slider
jQuery(function ($) {
  $(".xt-slider").slick({
    autoplay: true,
    arrows: false,
    dots: true,
    fade: false,
    pauseOnHover: true,
    adaptiveHeight: true,
    nextArrow: '<div class="nextArrowBtn slick-arrows"><svg viewBox="0 0 6 10" xmlns="http://www.w3.org/2000/svg"><path d="m6.03 1114.227 5.3 5 .7-.66-4.6-4.34 4.6-4.34-.7-.66z" fill-rule="evenodd" transform="matrix(-1 0 0 -1 12.029 1119.227)"/></svg></div>',
    prevArrow: '<div class="prevArrowBtn slick-arrows"><svg viewBox="0 0 6 10" xmlns="http://www.w3.org/2000/svg"><path d="m6.03 1114.227 5.3 5 .7-.66-4.6-4.34 4.6-4.34-.7-.66z" fill-rule="evenodd" transform="translate(-6.029 -1109.227)"/></svg></div>'
  });
  var $carousel = $('.xt-slider');
  $(document).on('keydown', function (e) {
    if (e.keyCode == 37) {
      $carousel.slick('slickPrev');
    }
    if (e.keyCode == 39) {
      $carousel.slick('slickNext');
    }
  });
});
//Logo Slider
jQuery(function ($) {
  $(".logo-slider").slick({
    autoplay: true,
    arrows: true,
    dots: false,
    fade: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    pauseOnHover: true,
    adaptiveHeight: true,
    responsive: [{
            breakpoint: 1024, // tablet breakpoint
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
        },
        {
            breakpoint: 640, // mobile breakpoint
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }
    ],
    nextArrow: '<div class="nextArrowBtn slick-arrows"><svg viewBox="0 0 6 10" xmlns="http://www.w3.org/2000/svg"><path d="m6.03 1114.227 5.3 5 .7-.66-4.6-4.34 4.6-4.34-.7-.66z" fill-rule="evenodd" transform="matrix(-1 0 0 -1 12.029 1119.227)"/></svg></div>',
    prevArrow: '<div class="prevArrowBtn slick-arrows"><svg viewBox="0 0 6 10" xmlns="http://www.w3.org/2000/svg"><path d="m6.03 1114.227 5.3 5 .7-.66-4.6-4.34 4.6-4.34-.7-.66z" fill-rule="evenodd" transform="translate(-6.029 -1109.227)"/></svg></div>'
  });
  var $carousel = $('.logo-slider');
  $(document).on('keydown', function (e) {
    if (e.keyCode == 37) {
      $carousel.slick('slickPrev');
    }
    if (e.keyCode == 39) {
      $carousel.slick('slickNext');
    }
  });
});
//Test Slider
jQuery(function ($) {
  $(".test-slider").slick({
    autoplay: true,
    arrows: false,
    dots: true,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
    adaptiveHeight: true,
    
    nextArrow: '<div class="nextArrowBtn slick-arrows"><svg viewBox="0 0 6 10" xmlns="http://www.w3.org/2000/svg"><path d="m6.03 1114.227 5.3 5 .7-.66-4.6-4.34 4.6-4.34-.7-.66z" fill-rule="evenodd" transform="matrix(-1 0 0 -1 12.029 1119.227)"/></svg></div>',
    prevArrow: '<div class="prevArrowBtn slick-arrows"><svg viewBox="0 0 6 10" xmlns="http://www.w3.org/2000/svg"><path d="m6.03 1114.227 5.3 5 .7-.66-4.6-4.34 4.6-4.34-.7-.66z" fill-rule="evenodd" transform="translate(-6.029 -1109.227)"/></svg></div>'
  });
  var $carousel = $('.test-slider');
  $(document).on('keydown', function (e) {
    if (e.keyCode == 37) {
      $carousel.slick('slickPrev');
    }
    if (e.keyCode == 39) {
      $carousel.slick('slickNext');
    }
  });
});
